/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminServiceUpdateInput } from "../../entities/models/AdminServiceUpdateInput";
import { z } from "zod/v4";

export const modelsAdminServiceUpdateInputSchema = z.object({
    "duration_minutes": z.int(),
"is_active": z.optional(z.boolean()),
"name": z.string(),
"price": z.number(),
"service_type": z.enum(["adult", "child", "adult_child"])
    }) as unknown as z.ZodType<ModelsAdminServiceUpdateInput>